import ArtistForm from "../../forms/ArtistForm";
import IconButton from "../../components/IconButton";
import RequestContainer from "../../components/RequestContainer";
import ViewContents from "../../components/ViewContents";
import ViewHeader from "../../components/ViewHeader";
import toast from "../../lib/toast";
import { Save } from "react-feather";
import { createArtist } from "../../clients/art";
import { useHistory } from "react-router-dom";
import { useQueryString } from "../../hooks/useQueryString";
import { useRequest } from "../../hooks/useRequest";

function NewArtist() {
  const eventId = useQueryString("eventId");
  const offerId = useQueryString("offerId");
  const saleId = useQueryString("saleId");
  const workId = useQueryString("workId");
  const createRequest = useRequest(createArtist);
  let history = useHistory();

  return (
    <ArtistForm
      onSubmit={(values, actions) => {
        const createOneMore =
          window.event.submitter.classList.contains("create-one-more");

        createRequest.execute(
          { ...values, eventId, offerId, saleId, workId },
          (response) => {
            if (createOneMore) {
              actions.resetForm();
            } else {
              history.push(`/artists/${response.data.id}`);
            }
            toast("The artist was created");
          }
        );
      }}
    >
      {(fields) => (
        <>
          <ViewHeader
            breadcrumbs={["New artist"]}
            actions={
              <>
                <IconButton
                  type="submit"
                  disabled={createRequest.loading}
                  icon={Save}
                  className="btn btn-secondary me-2 create-one-more"
                >
                  Save and create one more
                </IconButton>
                <IconButton
                  type="submit"
                  disabled={createRequest.loading}
                  icon={Save}
                  className="btn btn-success"
                >
                  Save
                </IconButton>
              </>
            }
          />
          <ViewContents>
            <RequestContainer
              loading={createRequest.loading}
              error={createRequest.error}
            >
              {fields}
            </RequestContainer>
          </ViewContents>
        </>
      )}
    </ArtistForm>
  );
}

export default NewArtist;
